// Shared utilities for hosted-sites components: formatting helpers and URL resolver

import { SITES_BASE } from '../../lib/api-client'
import type { HostedSite } from '../../hooks/use-hosted-sites'

export const DESCRIPTION_MAX = 500

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function formatDate(ts: number): string {
  return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

/** Full public URL for a hosted site (served from separate sites domain for credential isolation, GH-121) */
export function sitePublicUrl(site: HostedSite): string {
  if (SITES_BASE) return `${SITES_BASE}${site.url}`
  // Derive sites origin from current origin: app.X → sites.X, localhost → api.X (dev fallback)
  const origin = window.location.origin
  if (origin.includes('app.')) return `${origin.replace('app.', 'sites.')}${site.url}`
  // Dev: sites served from same origin via Vite proxy
  return `${origin}${site.url}`
}
